<template>
      
  <div class="containerMenuStyle">
    
<nav class="dashHomeMenuStyle">
    <jet-responsive-nav-link  :active="route().current('dashboard')"  :href="'/dashboard'" class="item " data-text="Dashboard">
        <!-- <i class="fas fa-home"></i> -->
        <i class="fa fa-th-large" aria-hidden="true"></i>

    </jet-responsive-nav-link >
</nav>

<nav class="dashMenuStyle"  v-for="(sideVal, sideKey) in prodData">
  
   <jet-responsive-nav-link    @click="gotoProductDashboard(sideVal.id,'product')" class="item " :data-text="sideVal.name">
        <!-- {{sideVal.name.substring(0, 2)}} -->
        <!-- {{route().current('*',sideVal.slug)}} -->
        {{sideVal.slug}}

    </jet-responsive-nav-link >
</nav>

  </div>  
</template>

<script>
import JetResponsiveNavLink from "@/Jetstream/ResponsiveNavLink.vue";
export default {
components:{
JetResponsiveNavLink
},
data(){
return{
prodData: [] ,
}
},
methods:{
checkPro()
{
return (this.prodData.length == 0);
},
getRelatedProduct(){
this.errors = {};
  axios
    .get("/admin/menus/getRelatedProduct")
    .then((response) => {
     // console.log("related Product", response);
    //console.log("test Product", response.data);
      this.prodData = response.data ;

    })
    .catch((error) => {
      console.log("Error", this.error);
      // alert("error");
    });
},
gotoProductDashboard($id,$type){
var data = {
selectedId:$id,
selectedType:$type
}
//console.log("seletedID",$id);
this.$inertia.get(route("seconddashboard"), data);
}
},
mounted(){
this.getRelatedProduct(); 
// console.log(route().current('*',sideVal.slug));

}
}
</script>

<style>
.containerMenuStyle{
min-height: 89.5vh;
background: white;

}
.dashMenuStyle{
  /* padding:0px 12px; */
display: flex;
flex-direction: column;
justify-content: flex-start;
 /* min-height: 100vh; */

text-align: center;
}
.dashHomeMenuStyle{
text-align: center;
}
/* nav{
display: flex;
flex-direction: column;
justify-content: flex-start;
position: fixed;
min-height: 100vh;
background-color: #f3f4f6;
text-align: center;
} */
.dashMenuStyle .item {
color: white;
/* font-size: 2rem; */
text-decoration: none;
position: relative;
}
.dashMenuStyle  i{
padding : 0.01em;
font-size: 1.2rem;
}
.dashMenuStyle .item:hover i{
color: blue;
}
.dashMenuStyle .item::after{
content: attr(data-text);
position: absolute;
font-size: 13px;
top: 50%;
white-space: nowrap;
padding:6px 15px;
border-radius: 2px;
background-color: #fdc031;
visibility: hidden;
opacity: 0;
transition: opacity 0.2s, transform 0.0s;
color: black;
margin-left: 25px;
}
.dashMenuStyle .item:hover::after{
visibility: visible;
transform: translate(10px,-50%);
opacity: 1;
}
.item {
  margin-top: 0.0001rem;
}
</style>